var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 62.5,
    r: 30,
    fill: "#1C1356"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 65,
    r: 20,
    fill: "#1C1356"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 65,
    r: 20,
    fill: "#1C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 135C45 118.431 58.4315 105 75 105H125C141.569 105 155 118.431 155 135V145C155 156.046 146.046 165 135 165H65C53.9543 165 45 156.046 45 145V135Z",
    fill: "#1C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.998 92.5H162.998C179.567 92.5 192.998 105.931 192.998 122.5V132.5H162.998V132.047C162.998 121.546 157.239 111.89 147.998 106.9V92.5Z",
    fill: "#1C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 92.5H37.5C20.9315 92.5 7.5 105.931 7.5 122.5V132.5H37.5V132.059C37.5 121.548 43.2576 111.881 52.5 106.875V92.5Z",
    fill: "#1C1356"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGroups);
export default __webpack_public_path__ + "static/media/empty-groups.363a3571.svg";
export { ForwardRef as ReactComponent };